export const SOURCES = {
  Rob: 'ROB-Net',
  TecRMI: 'TecRMI',
  LKQ: 'LKQ',
  PartsPoint: 'PartsPoint',
  Custom: 'Invoer',
  SlaTasks: 'Bahnkick activiteiten',
  Make: 'Fabrikant',

  // Vrooam sources
  koskamp: 'Koskamp',
  keulen: 'Keulen',
  tabb: 'T.A.B.B.',
  autoindus: 'AUTOINDUS',
  hofland: 'Hofland',
  remto: 'Remto',
  bachaus: 'Bachaus',
  grundeken: 'Grundeken',

  Vrooam: (source) => {
    switch (source) {
      case 'koskamp':
      case 'keulen':
      case 'tabb':
      case 'autoindus':
      case 'hofland':
      case 'remto':
      case 'bachaus':
      case 'grundeken':
        return true;
    }

    return false;
  },
};
